<template>
  <div class="login-page">
    <!-- 左侧：背景大图和标题 -->
    <div class="left-panel">
      <div class="brand">
        <div class="logo">
			<img :src="box.logo" alt="" srcset="" />
		</div>
        <div class="title-cn">{{box.site_title}}</div>
        <div class="title-en">Connecting Experts, Designing the Future of Energy</div>
      </div>
    </div>
    <!-- 右侧：登录卡片 -->
    <div class="right-panel">
      <div class="login-card" v-if="type==1" style="width:460px;">
        <div class="welcome-title">欢迎登录</div>
        <div class="welcome-subtitle">Welcome to Oil Equipment Design Platform</div>
        <form class="login-form" @submit.prevent="onSubmit">
          <!-- 手机号 -->
          <div class="form-item">
            <div class="input-prefix">
              <span class="icon-phone"></span>
            </div>
            <input v-model="phone" type="text" placeholder="请输入手机号" class="input" />
          </div>
          <!-- 验证码 -->
          <div class="form-item code-row">
            <input v-model="code" type="text" placeholder="请输入手机验证码" class="input"/>
            <button 
              type="button" 
              class="btn secondary" 
              @click="handleSendCode"
              :disabled="countdown > 0"
            >
              {{ countdown > 0 ? `${countdown}秒后重试` : '发送验证码' }}
            </button>
          </div>
          <!-- 登录按钮 denglu--> 
          <button type="submit" class="btn primary full" @click="onSubmit"> 登录 </button>
          <!-- 协议勾选 -->
          <div class="agreement">
            <label>
              <input type="checkbox" v-model="agree" />
              <span>我已阅读并接受《用户协议》及《隐私协议》</span>
            </label>
          </div>
        </form>
      </div>
	  <div v-if="type==2" style="width: 520px;">
	  	<div class="title">
			<div class="title1">Hi，很高兴见到您</div>
			<div class="title2">请问您想？</div>
		</div>
		<div class="leixing">
			<div class="leixing1" @click="FBxq">
				<img src="@/assets/fabu.png" />
				<div class="leixing1_1">
					<div>我要发布需求</div>
					<p>企业/工厂寻找专业设计服务</p>
				</div>
			</div>
			<div class="leixing1" @click="FuFang">
				<img src="@/assets/xuqiu.png" />
				<div class="leixing1_1">
					<div>我要承接项目</div>
					<p>专业设计/工程承接项目需求</p>
				</div>
			</div>
		</div>
	  </div>
	  <div v-if="type==3" style="width:460px;">
		  <div class="welcome-title">欢迎登录</div>
		  <div class="welcome-subtitle">Welcome to Oil Equipment Design Platform</div>
		  <div class="fwxinxi">请完善服务方信息</div>
		  <el-form 
		       :model="ruleForm" 
			   :label-position="labelPosition" 
			   :rules="rules" ref="ruleForm" 
			   label-width="100px" 
			   class="demo-ruleForm">
				<el-form-item label="工作年限" prop="name" style="text-align:left;color:#fff;">
				   <el-select v-model="ruleForm.name" placeholder="请选择" style="width:100%;">
				       <el-option
				         v-for="(item,index) in work_year"
				         :key="index"
				         :label="item.name"
				         :value="item.dict_value">
				       </el-option>
				     </el-select>
				</el-form-item>
				<el-form-item label="擅长技能（行业类型）" prop="name" style="text-align:left;color:#fff;">
				   <el-select 
				     v-model="ruleForm.lexing" 
					 :multiple-limit="5"
					 multiple
					 collapse-tags
					 placeholder="请选择擅长技能" 
					 style="width:100%;">
				       <el-option
				         v-for="(item,index) in industry"
				         :key="index"
				         :label="item.name"
				         :value="item.dict_value">
				       </el-option>
				     </el-select>
				</el-form-item>
		  </el-form>
		  <div class="tiaojie">
			  <div class="tiaojie1">
				  <p>是否加入评审团参与纠纷调解</p>
				  <span>参与评审团可获得评审金奖励</span>
			  </div>
			  <el-switch v-model="ruleForm.delivery"></el-switch>
		  </div>
		   <!-- 使用普通按钮类型，避免触发表单提交导致页面刷新，影响路由跳转 -->
		   <button type="button" class="btn primary full" @click="denglu2" style="margin-top:24px;"> 提交 </button>
	  </div>
    </div>
  </div>
</template>

<script>
import { login, BaseSendSms,setUserType,BaseGetConfig,dictValue} from '@/api/api'
export default {
  name: 'HelloWorld',
  data() {
    return {
	  ruleForm:{
		name:"",
		lexing:"",
		delivery:false
	  },
	  rules: {
		name:[
		  { required: true, message: '请选择工作年限', trigger: 'blur' },
		],
		lexing:[
		  { required: true, message: '请选择擅长技能', trigger: 'blur' },
		]
	  },
	  industry: [], //类型
	  work_year: [], //时间
      phone: '',
      code: '',
      agree: true,
      countdown: 0, // 验证码倒计时
      timer: null,
	  type:1,
	  labelPosition:'top',
	  verify_id:"",
	  tokens:"",
	  denglus:"",
	  box:""
    }
  },
  created() {
	  this.getBaseGetConfig()
	   this.getdictValue()
  	  this.denglus=localStorage.getItem("userType")
	  if(this.denglus){
		 this.type=2
		
	  }else{
		 this.type=1 
	  }
  },
  methods: {
	  getdictValue(){
	  	dictValue({
	  		key:"industry,work_year"
	  	}).then(res=>{
	  		this.industry=res.data.data.industry
	  		this.work_year=res.data.data.work_year
	  		this.work_year.forEach(item =>{
	  			item.text=item.name
	  			item.value=item.dict_value
	  		})
	  	})
	},
	getBaseGetConfig(){
		BaseGetConfig({
			key:"logo,site_title"
		}).then(res=>{
			this.box=res.data.data
			localStorage.setItem("login",res.data.data.logo)
			localStorage.setItem("site_title",res.data.data.site_title)
		})
	}, 
	denglu(){
		this.type=2 
	},
	//绑定身份 -需求方
	FBxq(){
		this.type=1
		this.leixing="cuqiu"
		// 绑定为需求方
		// if(this.denglus){
		// 	if (this.$route.path !== '/demandHome/demandIndex') {
		// 	    this.$router.push('/demandHome/demandIndex')
		// 	}
		// }else{
		// 	this.type=2
		// }
	},
	FuFang(){
		this.type=1
		this.leixing="fuwu"
		// if(this.denglus){
		// 	setUserType({
		// 		user_type:"2"
		// 	}).then(res=>{
		// 		console.log(res)
		// 		if(res.data.status==200){
		// 			if (this.$route.path !== '/demandHome/demandIndex') {
		// 			    this.$router.push('/demandHome/demandIndex')
		// 			}
		// 		}else{
		// 			 this.$message.error(res.data.msg)
		// 			  this.type=1
		// 		}
		// 	})
		// }else{
		// 	this.type=2
		// }
	},
	bangding(){
		let sansh=''
		if(this.leixing=='cuqiu'){
			sansh="1"
		}
		if(this.leixing=='fuwu'){
			sansh="2"
		}
		
		
		setUserType({
			user_type:sansh
		}).then(res=>{
			console.log(res)
			if(res.data.status==200){
				if(sansh==1){
					if (this.$route.path !== '/demandHome/demandIndex') {
					    this.$router.push('/demandHome/demandIndex')
					}
				}else{
					this.type=3
				}
			}else{
				this.$message.error(res.data.msg)
				this.type=1
			}
		})
	},
	denglu2(){
		
	},
    // 发送验证码
    handleSendCode() {
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      // 简单的手机号验证
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      BaseSendSms({
        mobile: this.phone,
		scene:"login"
      }).then( res => {
		this.verify_id=res.data.data.verify_id
        this.$message.success('验证码已发送')
        // 开始倒计时
        this.countdown = 60
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }).catch(error => {
        this.$message.error(error.message || '发送验证码失败')
      })
    },
    // 登录
    onSubmit() {
      if (!this.agree) {
        this.$message.warning('请先勾选同意相关协议')
        return
      }
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.code) {
        this.$message.warning('请输入验证码')
        return
      }
      login({
        phone: this.phone,
        code: this.code,
		verify_id:this.verify_id
      }).then(res => {
		if(res.data.status==200){
			this.$message.success('登录成功!')
			this.userinfo=res.data.data
			this.tokens=res.data.token
			localStorage.setItem('token', res.data.token)
			localStorage.setItem('userinfo', res.data.data)
			if(this.userinfo.userType==0){
				this.type=2 
				this.bangding()
				localStorage.setItem('userType', this.type)
			}
			if(this.userinfo.userType==1){
				localStorage.setItem('userType', this.userinfo.userType)
				if (this.$route.path !== '/demandHome/demandIndex') {
				    this.$router.push('/demandHome/demandIndex')
				}
			}
			if(this.userinfo.userType==2){
				localStorage.setItem('userType', this.userinfo.userType)
				if(this.userinfo.complete){
					this.type=3
				}else{
					if (this.$route.path !== '/serviceHome/serviceindex') {
					    this.$router.push('/serviceHome/serviceindex')
					}
				}
			}
		}else{
			this.$message.error(res.data.msg)
		}
      }).catch(error => {
        this.$message.error(error.message || '登录失败')
      })
    }
  },
  
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Microsoft YaHei', sans-serif;
}
/* 左侧背景区域 */
.left-panel {
  flex: 1;
  position: relative;
  background-image: url('@/assets/back.png'); /* 这里换成你自己的工业背景图 */
  background-size: cover;
  background-position: center;
}
.left-panel::after {
  /* 轻微蒙版，增强可读性 */
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(0, 36, 82, 0.5),
    rgba(0, 36, 82, 0.1)
  );
}
.brand {
  position: absolute;
  left: 80px;
  top: 80px;
  color: #ffffff;
  z-index: 1;
}

.logo {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
}

.title-cn {
  font-size: 32px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.title-en {
  font-size: 12px;
  opacity: 0.8;
}

/* 右侧登录区域 */
.right-panel {
  width:680px;
  min-width: 400px;
  height: 100vh;
  position:absolute;
  right:0;
  display: flex;
  align-items: center;
  justify-content: center;
 background: linear-gradient(
   to right,
   rgba(247, 250, 255, 0.8),
   rgba(247, 250, 255, 0.1)
 );
  backdrop-filter: blur(10px);
}

.login-card {
  width: 360px;
  padding: 40px 32px 32px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 20px 40px rgba(15, 35, 95, 0.18);
}

.welcome-title {
  font-size: 26px;
  font-weight: 600;
  color: #1f2d3d;
  text-align: center;
}

.welcome-subtitle {
  margin-top: 8px;
  font-size: 12px;
  color: #8c9bb3;
  text-align: center;
}

.login-form {
  margin-top: 32px;
}

.form-item {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.input-prefix {
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
  color: #c0c4cc;
}

/* 简单模拟一个手机图标 */
.icon-phone {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 2px solid currentColor;
  position: relative;
}

.icon-phone::after {
  content: '';
  position: absolute;
  left: 2px;
  right: 2px;
  bottom: 2px;
  height: 2px;
  background: currentColor;
  border-radius: 2px;
}

.input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px 10px 36px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
}

.input::placeholder {
  color: #c0c4cc;
}

.input:focus {
  border-color: #3b6af1;
  box-shadow: 0 0 0 2px rgba(59, 106, 241, 0.1);
}

.code-row .input {
  padding-left: 12px;
}

.code-row {
  gap: 12px;
}

.btn {
  border: none;
  cursor: pointer;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.btn.primary {
  background: #2650d8;
  color: #ffffff;
}

.btn.primary:hover {
  background: #1f42b6;
}

.btn.secondary {
  background: #f2f5ff;
  color: #2650d8;
  border: 1px solid #d6defa;
  white-space: nowrap;
}

.btn.secondary:hover {
  background: #e5ecff;
}

.btn.full {
  width: 100%;
  margin-top: 8px;
}

.agreement {
  margin-top: 16px;
  font-size: 12px;
  color: #909399;
}

.agreement label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.agreement input[type='checkbox'] {
  margin-right: 6px;
}
.title{
	width:100%;
	box-sizing: border-box;
	text-align: left;
}
.title1{
	font-weight: 400;
	font-size: 18px;
	color: #1E3A8A;
}
.title2{
	font-weight: bold;
	font-size: 32px;
	color: #1E3A8A;
}
.leixing1{
	width: 460px;
	height: 126px;
	background: #FFFFFF;
	box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
	border-radius: 12px 12px 12px 12px;
	margin-top:32px;
	padding:32px;
	box-sizing: border-box;
	display:flex;
	align-items: center;
	cursor: pointer;
}
.leixing1 img{
	width:42px;
	height:42px;
	margin-right:24px;
}
.leixing1_1 div{
	text-align:left;
	font-weight: 800;
	font-size: 20px;
	color: #333333;
}
.fwxinxi{
	font-weight: 500;
	font-size: 18px;
	color: #333333;
	text-align:left;
	margin-top:32px;
	margin-bottom:24px;
}
.leixing1_1 p{
	font-weight: 500;
	font-size: 16px;
	color: #999999;
}
::v-deep .el-form-item__label{
	font-weight: 400 !important;
	font-size: 16px !important;
	color: #333333 !important;
}
.tiaojie{
	width:100%;
	display:flex;
	align-items: center;
	justify-content:space-between;
}
.tiaojie1{
	text-align:left;
}
.tiaojie1 p{
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	margin:0;
}
.tiaojie1 span{
	font-weight: 400;
	font-size: 14px;
	color: #1E3A8A;
}
</style>